import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AIDocumentProcessorIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(5 3)">
      <g fill="currentColor">
        <path
          d="m7 0v2h-4.97775531v14h4.97775531v2h-5.34579412c-.86625962 0-1.57584646-.7269806-1.6481402-1.6452719l-.00606568-.1547281v-14.4c0-.99.74813331-1.8 1.66251847-1.8z"
          fillRule="nonzero"
        />
        <path d="m4 12.5h3v1.5h-3z" fillRule="nonzero" />
        <path d="m4 9.5h3v1.5h-3z" fillRule="nonzero" />
        <path d="m4 6.5h3v1.5h-3z" fillRule="nonzero" />
        <circle cx="11.5" cy="16.5" r="1.5" transform="matrix(1 0 0 -1 0 33)" />
        <circle cx="13.5" cy="7.5" r="1.5" transform="matrix(1 0 0 -1 0 15)" />
        <circle cx="10.5" cy="2.5" r="1.5" />
      </g>
      <path
        d="m8 7.5h.81417625c1.91570885 0 1.67624525-.7032967 1.67624525-4"
        stroke="currentColor"
      />
      <path
        d="m8 10.4938462h.81279457c3.77710423 0 4.73333313.2215384 4.68552163-1.9938462"
        stroke="currentColor"
      />
      <path
        d="m8 15.4916974h.51704781c2.78062219.0061472 3.01104309.2212997 2.98062859-1.9916974"
        stroke="currentColor"
        transform="matrix(1 0 0 -1 0 29)"
      />
    </g>
  </Icon>
);
